export default 'MARVEL_DESIGN_CREATOR';
